import { apiRequest } from './client'

export type CreateVenuePayload = {
  legal_name: string
  trade_name: string
  ogrn: string
  city: string
  horeca_type: string
}

export type BuyerVenueDto = {
  id: number
  name: string
  legal_name?: string | null
  trade_name?: string | null
  ogrn?: string | null
  /** Legacy: у точек, заведённых до перехода на ОГРН. */
  inn?: string | null
  city?: string | null
  horeca_type?: string | null
  sort_order: number
  active: boolean
  created_at: string
}

type RawVenue = {
  id?: number
  name?: string
  legal_name?: string | null
  trade_name?: string | null
  ogrn?: string | null
  /** Legacy: у точек, заведённых до перехода на ОГРН. */
  inn?: string | null
  city?: string | null
  horeca_type?: string | null
  sort_order?: number
  active?: boolean
  created_at?: string
}

const normalizeVenue = (raw: RawVenue): BuyerVenueDto => ({
  id: Number(raw.id ?? 0),
  name: String(raw.name ?? ''),
  legal_name: raw.legal_name ?? null,
  trade_name: raw.trade_name ?? null,
  ogrn: raw.ogrn ?? null,
  inn: raw.inn ?? null,
  city: raw.city ?? null,
  horeca_type: raw.horeca_type ?? null,
  sort_order: Number(raw.sort_order ?? 0),
  active: raw.active ?? true,
  created_at: raw.created_at ?? new Date(0).toISOString(),
})

export const createOrganizationVenue = async (organizationId: number, payload: CreateVenuePayload) => {
  const item = await apiRequest<RawVenue>(`/organizations/${organizationId}/venues`, {
    method: 'POST',
    body: payload,
  })
  return normalizeVenue(item)
}
